import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    DesignSize:{
      DesignWidth:1125,//设计宽度
      DesignHeight:1496,//设计高度
      SafeWidth:750,//安全区宽度
      SafeHeight:1206,//安全区高度
    },
    WindowSize:{
      WindowWidth:window.innerWidth,//屏幕宽度
      WindowHeight:window.innerHeight,//屏幕高度
      WindowWidthRem:window.innerWidth,//屏幕宽度
      WindowHeightRem:window.innerHeight,//屏幕高度
    },
    AutoPositon:{
      width:0,
      height:0,
      OffsetX:0,
      OffsetY:0,
      FontSize:0,
    },
    issue:2,
    ShareInfo:{
      title:"动见|增长创意",
      desc: "让创意成为真正意义上可追踪、可理解 、可持续的生意增长引擎",
      link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_2.html?chanel=1",
      icon: "icon.jpg",
      count:0,
      issue:2
    },
    viewImageSrc:''
  },
  mutations: {
    SetWindowSize (state) {
      state.WindowSize.WindowWidth=window.innerWidth;
      state.WindowSize.WindowHeight=window.innerHeight;

      let WindowP=state.WindowSize.WindowWidth/state.WindowSize.WindowHeight;
      let SafeP=state.DesignSize.SafeWidth/state.DesignSize.SafeHeight;
      let p=0
      if(WindowP<SafeP){
        p=state.WindowSize.WindowWidth/state.DesignSize.SafeWidth;
        state.AutoPositon.width=state.DesignSize.DesignWidth*p+'px';
        state.AutoPositon.height=state.DesignSize.DesignHeight*p+'px';
        state.AutoPositon.OffsetX=
          (state.DesignSize.SafeWidth-state.DesignSize.DesignWidth)/2*p+'px';
        state.AutoPositon.OffsetY=
          (state.WindowSize.WindowHeight-state.DesignSize.DesignHeight*p)/2+'px';
        state.AutoPositon.FontSize=
          100*p+'px';
      }else{
        p=state.WindowSize.WindowHeight/state.DesignSize.SafeHeight;
        state.AutoPositon.width=state.DesignSize.DesignWidth*p+'px';
        state.AutoPositon.height=state.DesignSize.DesignHeight*p+'px';
        state.AutoPositon.OffsetX=
          (state.WindowSize.WindowWidth-state.DesignSize.DesignWidth*p)/2+'px';
        state.AutoPositon.OffsetY=
          (state.DesignSize.SafeHeight-state.DesignSize.DesignHeight)/2*p+'px';
        state.AutoPositon.FontSize=
          100*p+'px';
      }
      state.WindowSize.WindowWidthRem=state.WindowSize.WindowWidth/(100*p);
      state.WindowSize.WindowHeightRem=state.WindowSize.WindowHeight/(100*p);
      document.documentElement.style.fontSize=
        state.AutoPositon.FontSize;
    },
    WindowSizeNoSet (state,id) {
      if(!id) id='app';
      state.WindowSize.WindowWidth=window.innerWidth;
      state.WindowSize.WindowHeight=window.innerHeight;
      let WindowP=state.WindowSize.WindowWidth/state.WindowSize.WindowHeight;
      let SafeP=state.DesignSize.SafeWidth/state.DesignSize.SafeHeight;
      if(WindowP>SafeP) {
        state.WindowSize.WindowWidth=SafeP*state.WindowSize.WindowHeight;
      }
      document.getElementById(id).style.position="absolute";
      document.getElementById(id).style.left=(window.innerWidth-state.WindowSize.WindowWidth)/2+'px';
      document.getElementById(id).style.width=state.WindowSize.WindowWidth+'px';
      state.WindowSize.WindowWidthRem=state.DesignSize.DesignWidth/100;
      state.WindowSize.WindowHeightRem=state.WindowSize.WindowHeight/state.WindowSize.WindowWidth*state.DesignSize.DesignWidth/100;

      document.documentElement.style.fontSize=
        100*state.WindowSize.WindowWidth/state.DesignSize.DesignWidth+'px';
    },
    setShareInfo(state,info){
      state.ShareInfo=info;
    },
    setImageSrc(state,src){
      state.viewImageSrc=src;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js